import { useRef, type KeyboardEvent } from 'react'
import { adminSectionLabels, adminSections, panelId, tabId, type AdminSection } from './adminSections'

/**
 * The row of sections at the top of the administration, one open at a time. The arrows, Home and End move the focus
 * along the row and Enter or Space opens the focused one, so a key press does not load a section by accident.
 */
export function AdminTabs({ selected, onSelect }: { selected: AdminSection; onSelect: (section: AdminSection) => void }) {
  const list = useRef<HTMLDivElement>(null)

  function onKeyDown(event: KeyboardEvent<HTMLDivElement>) {
    const tabs = Array.from(list.current?.querySelectorAll<HTMLButtonElement>('[role="tab"]') ?? [])
    const index = tabs.indexOf(document.activeElement as HTMLButtonElement)
    if (index < 0) return
    const target = event.key === 'ArrowRight' ? (index + 1) % tabs.length
      : event.key === 'ArrowLeft' ? (index + tabs.length - 1) % tabs.length
      : event.key === 'Home' ? 0
      : event.key === 'End' ? tabs.length - 1
      : -1
    if (target < 0) return
    event.preventDefault()
    tabs[target]?.focus()
  }

  return <div ref={list} role="tablist" aria-label="Secciones de la administración" className="admin-tabs" onKeyDown={onKeyDown}>
    {adminSections.map((section) => <button key={section} type="button" role="tab" id={tabId(section)} aria-selected={section === selected} aria-controls={panelId(section)}
      tabIndex={section === selected ? 0 : -1} onClick={() => onSelect(section)}>{adminSectionLabels[section]}</button>)}
  </div>
}
